import React, { ChangeEventHandler, FocusEventHandler } from 'react';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';
import { Dispatch } from 'redux';

import TextField from '../../TextField/TextField';
import {
  flatIsVisible,
  getFlat,
  PersonModel,
} from '../../../../selectors/addressUnmodeled';
import { getAddressPlaceholder } from '../../../../helpers/getPlacelholder';
import { FLAT_PATTERN } from '../../../../constants/REGEXP_PATTERNS';
import { trimOnBlur } from '../../../../helpers/handlers';
import { AddressFields } from '../../../../../types/address';
import { ADDRESS_INFO_FIELD_NAME } from '../../../../constants/address';

interface StateProps {
  flat: AddressFields['flat'];
  isVisible: boolean;
}

interface DispatchProps {
  onChange: ChangeEventHandler;
  onBlur: FocusEventHandler;
}

interface OwnProps {
  model: PersonModel;
  forManualInput?: boolean;
  isExpandedView?: boolean;
}

type Props = OwnProps & StateProps & DispatchProps;

function AddressFlat({
  flat,
  forManualInput,
  onChange,
  onBlur,
  isVisible,
}: Props): JSX.Element | null {
  if (!isVisible) return null;
  const field = (
    <TextField
      className="PguFormGrid_col PguFormGrid__col_2"
      placeholder={getAddressPlaceholder('flat')}
      inputProps={{
        name: ADDRESS_INFO_FIELD_NAME.flat,
        onChange,
        onBlur,
        maxLength: 15,
        ...flat,
      }}
      maskOptions={{
        regex: FLAT_PATTERN.FOR_INPUT_MASK,
        placeholder: ' ',
        showMaskOnFocus: false,
        showMaskOnHover: false,
      }}
    />
  );
  if (!forManualInput) {
    return <div className="PguFormGrid__row">{field}</div>;
  }
  return field;
}

const mapStateToProps = createStructuredSelector({
  flat: getFlat,
  isVisible: flatIsVisible,
});

function mapDispatchToProps(dispatch: Dispatch, { model }) {
  return {
    onChange({ target: { name, value } }) {
      dispatch({
        type: `${model}/address/change`,
        payload: { [name]: value },
      });
    },
    onBlur: trimOnBlur(model, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressFlat);
